import React, { useState } from "react";
import "./Tintuc.css";

export default function Tintuc() {
  // ========== TÙY CHỈNH DỮ LIỆU TIN TỨC TẠI ĐÂY ==========
  const news = [
    {
      id: 1,
      title: "Ý nghĩa các chế độ thường gặp trên remote máy lạnh",
      category: "Dịch Vụ Điện Lạnh",
      img: "/remote.jpg", // ← ĐỔI THÀNH ẢNH CỦA BẠN
    },
    {
      id: 2,
      title: "Vì sao máy lạnh chạy một lúc rồi tắt đột ngột",
      category: "Dịch Vụ Điện Lạnh",
      img: "/maylanhbv.png",
    },
    {
      id: 3,
      title: "Vệ sinh máy lạnh trọn gói bao sạc Gas",
      category: "Dịch vụ bơm gas, vệ sinh máy lạnh",
      img: "/maylanhbv3.png",
    },
    {
      id: 4,
      title: "Vệ sinh máy lạnh tại TPHCM",
      category: "Dịch vụ điện lạnh, vệ sinh máy lạnh",
      img: "/maylanhbv4.jpg",
    },
  ];
  // =========================================================

  const [index, setIndex] = useState(0);

  const next = () => {
    setIndex((prev) => (prev + 1) % news.length);
  };

  const prev = () => {
    setIndex((prev) => (prev - 1 + news.length) % news.length);
  };

  return (
    <section className="news-wrapper">
      <h2 className="news-title">
        <span className="star">★</span> TIN TỨC & KHUYẾN MÃI
      </h2>

      {/* PC layout */}
      <div className="news-grid-pc">
        {news.map((item) => (
          <div key={item.id} className="news-card">
            <img src={item.img} alt={item.title} className="news-img" />
            <div className="news-cat">{item.category}</div>
            <h3 className="news-heading">{item.title}</h3>
            <div className="news-readmore">XEM THÊM</div>
          </div>
        ))}
      </div>

      {/* Mobile Carousel */}
      <div className="news-carousel-mobile">
        <button className="nav-btn left" onClick={prev}>‹</button>

        <div className="news-card mobile">
          <img
            src={news[index].img}
            alt={news[index].title}
            className="news-img"
          />
          <div className="news-cat">{news[index].category}</div>
          <h3 className="news-heading">{news[index].title}</h3>
          <div className="news-readmore">XEM THÊM</div>
        </div>

        <button className="nav-btn right" onClick={next}>›</button>
      </div>
    </section>
  );
}